import React, { FC, useEffect, useState } from 'react'
import * as S from './styles'
import { TabProps } from './types'
import { Icon, Text } from '../'

export const Tabs: FC<TabProps> = ({
  steps,
  stepActive,
  price,
  resume,
  action,
  kind,
  isDisabled,
  serviceType,
  endingStepNumber
}) => {
  const [previousStep, setPreviousStep] = useState<number>(1)
  const [nextStep, setNextStep] = useState<number>(1)

  useEffect(() => {
    switch (!!steps) {
      case serviceType === 'basic' && stepActive === 7:
        setPreviousStep(Math.max(1, stepActive - 4))
        break
      case serviceType === 'premium' && stepActive === 7:
        setPreviousStep(Math.max(1, stepActive - 2))
        break
      case serviceType === 'smart' && stepActive === 7:
        setPreviousStep(Math.max(1, stepActive - 4))
        break
      case serviceType === 'pro' && stepActive === 7:
        setPreviousStep(Math.max(1, stepActive - 3))
        break
      default:
        setPreviousStep(Math.max(1, stepActive - 1))
        break
    }
    if (stepActive !== endingStepNumber) {
      switch (true) {
        case serviceType === 'basic' && stepActive === 3:
          setNextStep(stepActive + 4)
          break
        case serviceType === 'premium' && stepActive === 5:
          setNextStep(stepActive + 2)
          break
        case serviceType === 'smart' && stepActive === 3:
          setNextStep(stepActive + 4)
          break
        case serviceType === 'pro' && stepActive === 4:
          setNextStep(stepActive + 3)
          break
        default:
          setNextStep(stepActive + 1)
          break
      }
    }
  }, [steps])

  const handleStepClick = (stepKey) => {
    if (isDisabled || stepActive === endingStepNumber) {
      return false
    } else {
      action && action(stepKey)
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 660) {
        document.body.classList.add('scrolled')
      } else {
        document.body.classList.remove('scrolled')
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <S.TopBar>
      <S.StepsWrapper>
        <S.Steps>
          {kind === 'withIcon' && (
            <>
              <S.LeftButton
                active={stepActive === 1}
                onClick={() => action && action(previousStep)}
                id={stepActive !== 1 ? 'calc_step_p' + `${stepActive - 1}` : 'calc_step_p'}
              >
                <Icon name='slide-left' size='s5' />
              </S.LeftButton>
              <S.RightButton
                finished={stepActive === steps.length}
                isDisabled={isDisabled || stepActive === endingStepNumber}
                onClick={() => action && action(nextStep)}
                id={'calc_step_n' + stepActive}
              >
                <Icon name='slide-right' size='s5' />
              </S.RightButton>
            </>
          )}
          {steps.map((step, index) => (
            <S.Step
              key={step.id}
              active={stepActive === step.key}
              finished={stepActive > step.key}
              before={previousStep === step.key}
              after={nextStep === step.key}
              initial={index === stepActive + 1}
              onClick={() => handleStepClick(step.key)}
              id={'calc_' + step.id}
              isDisabled={isDisabled}
            >
              {index !== 0 && <S.NextIcon name='chevron-right' />}
              {stepActive < step.key && <S.StepNumber active={stepActive === step.key}>{''}</S.StepNumber>}
              {stepActive >= step.key && (
                <S.StepNumber active finished={stepActive > step.key}>
                  {stepActive > step.key ? <Icon name='checkmark' /> : '...'}
                </S.StepNumber>
              )}
              <span dangerouslySetInnerHTML={{ __html: step.name }} />
            </S.Step>
          ))}
        </S.Steps>
        <S.TopCalculatorGradient />
      </S.StepsWrapper>
      {price && (
        <S.TopCalculatorPrice>
          <Text size='xlg' color='primary-light' family='heading' weight='bold' align='right' margin='0'>
            {price}
          </Text>
          <Text size='xxxs' color='paleAlpha' align='right' margin='0' italic lineHeight='1.2'>
            {resume}
          </Text>
        </S.TopCalculatorPrice>
      )}
    </S.TopBar>
  )
}
